import Section from '../components/Section';
import { DataContainer } from '../components/DataContainer';
import BrandFilter from '../components/BrandFilter';
import NewQueriesTable from '../tables/NewQueriesTable';
/* import AnsweredQueriesTable from '../tables/AnsweredQueriesTable'; */

import { useDispatch } from 'react-redux';
import ConfirmedQueriesTable from '../tables/ConfirmedQueriesTable';
import UpcomingJobsTable from '../tables/UpcomingJobsTable';
import AnsweredQueriesTable from '../tables/AnsweredQueriesTable';
import { fetchAll } from '../store/shownDataSlice';
import { useEffect } from 'react';




function AdminHome() {
    const dispatch = useDispatch();
  
    useEffect(() => {
        dispatch(fetchAll());
    }, []);

    return (
        <div className="column g32 p32">
            <div className="row g16 center-cross">
                <button onClick={() => dispatch(fetchAll())}>Värskenda</button>
                <BrandFilter />
            </div>

            <Section title="Hiljutised päringud (vaja hinnaga vastata)">
                <DataContainer actionType={'shownData/fetch/newQueries'}>
                    <NewQueriesTable />
                </DataContainer>
            </Section>

            <Section title="Kinnitatud pakkumised (vaja juht määrata)">
                <DataContainer actionType={'shownData/fetch/confirmedQueries'}>
                    <ConfirmedQueriesTable />
                </DataContainer>
            </Section>

            <Section title="Tulevased tööd">
                <DataContainer actionType={'shownData/fetch/upcomingJobs'}>
                    <UpcomingJobsTable />
                </DataContainer>
            </Section>

            <Section title="Vastatud päringud (ootavad kliendi kinnitust)">
                <DataContainer actionType={'shownData/fetch/answeredQueries'}>
                    <AnsweredQueriesTable />
                </DataContainer>
            </Section>
        </div>
    );
}

export default AdminHome;